import { defineStore } from 'pinia'

export const useMainStore = defineStore('globalStore', () => {
    const embedOptions = useEmbed()

    return { embedOptions }
})
